export type OverlayProps = {
  expanded: boolean;
};

/**
 * Styled Box, which functions as overlay with an animated height.
 */
export const Overlay = ({ expanded }: OverlayProps) => (
  <div
    className={`from-color-background-base absolute right-0 bottom-0 left-0 bg-gradient-to-t to-transparent transition-all will-change-[height] ${expanded ? 'h-0' : 'h-[4rem]'}`}
  />
);
